import React, { Component } from 'react';
import styles from './colorpicker.less.js';
import { EnvContext } from '../../../../controllers/workbench/context.js';
import Dropdown from '@tencent/dui/lib/components/Dropdown';
import { ColorGrid } from './color-grid.js';
import { RecentColors } from './recent-colors.js';
import Menu from '@tencent/dui/lib/components/Menu';
import Divider from '@tencent/dui/lib/components/Divider';
import { CustomSketch } from './custom-sketch.js';
import { rgbToHex } from '../../utils/color-change.js';

/**
 * @public
 */
var ColorFrom;
(function (ColorFrom) {
    ColorFrom["NONE"] = "none";
    ColorFrom["NO_COLOR"] = "no-color";
    ColorFrom["DEFAULT"] = "default";
    ColorFrom["RECENT"] = "recent";
    ColorFrom["CUSTOM"] = "custom";
})(ColorFrom || (ColorFrom = {}));
const STANDARD_COLORS = [
    '#FFFFFF',
    '#000000',
    '#FF0000',
    '#FF9900',
    '#FFFF00',
    '#98FA1C',
    '#6CDEFF',
    '#403ED6',
    '#ED41FD',
];
const PRESET_COLORS = [
    ['#E9E9E9', '#7B7B7B', '#FFC8B8', '#FFE1B2', '#FFF2CC', '#D9EAD3', '#DFF8FF', '#CFC7F4', '#FEE4FF'],
    ['#D9D9D9', '#5c5c5c', '#E99899', '#FFB84D', '#FFE59A', '#ACDB7E', '#85D4E6', '#8C7BE8', '#EE93F6'],
    ['#C4C4C4', '#333333', '#E06666', '#FB8D00', '#FFD966', '#87C120', '#4CC2EE', '#3F49B9', '#D041E1'],
    ['#9D9D9D', '#262626', '#CC0000', '#E75200', '#FFB700', '#678F00', '#0188FB', '#2741B1', '#A419D3'],
];
/**
 * 一个通用颜色选择器组件，可用于下拉菜单和次级菜单
 *
 * @deprecated
 * Workbench 计划不再提供颜色选择面板，可采用自行实现的版本
 *
 * @public
 */
class ColorPicker extends Component {
    constructor() {
        super(...arguments);
        this.handleTransparent = () => {
            this.handleSelect('transparent', ColorFrom.NO_COLOR);
        };
        this.handleCustom = (color, from) => {
            var _a, _b;
            this.saveRecent(color);
            (_b = (_a = this.props).onChange) === null || _b === void 0 ? void 0 : _b.call(_a, color, from);
            this.forceUpdate(); // 更新 Recent 显示
        };
        this.handleRecent = (color, from) => {
            var _a, _b;
            (_b = (_a = this.props).onChange) === null || _b === void 0 ? void 0 : _b.call(_a, color, from);
        };
        this.handleSelect = (color, from) => {
            var _a, _b;
            this.saveRecent(color);
            (_b = (_a = this.props).onChange) === null || _b === void 0 ? void 0 : _b.call(_a, color, from);
        };
        this.getRecents = () => {
            var _a;
            const selectColor = (_a = this.props.selected) !== null && _a !== void 0 ? _a : '';
            const recents = RecentColors.get().map(recent => recent.color);
            while (recents.length < 9) {
                recents.push('transparent');
            }
            // 场景：接入自定义取色器
            if (rgbToHex(recents[0]) !== selectColor) {
                this.saveRecent(selectColor);
            }
            return RecentColors.get().map(recent => recent.color);
        };
        this.handleMouseEnter = (color, from) => {
            var _a, _b;
            (_b = (_a = this.props).onColorEnter) === null || _b === void 0 ? void 0 : _b.call(_a, color, from);
        };
        this.handleMouseLeave = () => {
            var _a, _b;
            (_b = (_a = this.props).onColorLeave) === null || _b === void 0 ? void 0 : _b.call(_a);
        };
        this.handleColorPanelLeave = () => {
            var _a, _b;
            (_b = (_a = this.props).onPanelLeave) === null || _b === void 0 ? void 0 : _b.call(_a);
        };
        this.getRecentSelected = () => {
            if (this.props.selected) {
                const otherSelected = STANDARD_COLORS.concat(...PRESET_COLORS).includes(this.props.selected);
                return otherSelected ? '' : this.props.selected;
            }
            return '';
        };
    }
    saveRecent(color) {
        if (color !== 'transparent') {
            RecentColors.save(color);
        }
    }
    render() {
        var _a;
        const selectColor = (_a = this.props.selected) !== null && _a !== void 0 ? _a : '';
        const recents = this.getRecents();
        return (React.createElement("div", { className: styles['toolbar-dropdown-panel-wrapper-auto'] },
            this.props.showNoColor && React.createElement("div", { className: styles['color-picker-transparent'], onClick: this.handleTransparent }, this.props.noColorText),
            React.createElement("div", { onMouseLeave: () => this.handleColorPanelLeave() },
                React.createElement(ColorGrid, { selected: selectColor, colors: [STANDARD_COLORS], onColorClick: (color) => this.handleSelect(color, ColorFrom.DEFAULT), onColorEnter: (color) => this.handleMouseEnter(color, ColorFrom.DEFAULT), onColorLeave: () => this.handleMouseLeave() }),
                React.createElement("div", { style: { height: 8 } }),
                React.createElement(ColorGrid, { selected: selectColor, colors: PRESET_COLORS, onColorClick: (color) => this.handleSelect(color, ColorFrom.DEFAULT), onColorEnter: (color) => this.handleMouseEnter(color, ColorFrom.DEFAULT), onColorLeave: () => this.handleMouseLeave() }),
                React.createElement("div", { className: styles.text, style: { marginTop: 3, paddingLeft: 12 } }, this.props.recentColorsText),
                React.createElement(ColorGrid, { selected: this.getRecentSelected(), colors: [recents], onColorClick: (color) => this.handleRecent(color, ColorFrom.RECENT), onError: () => RecentColors.clear(), onColorEnter: (color) => this.handleMouseEnter(color, ColorFrom.RECENT), onColorLeave: () => this.handleMouseLeave() })),
            React.createElement("div", { style: { height: 2 } }),
            this.props.showSubPalette && React.createElement(Divider, null),
            this.props.showSubPalette && React.createElement(Menu.SubMenu, { title: React.createElement(React.Fragment, null,
                    React.createElement("svg", { width: "16px", height: "16px", viewBox: "0 0 16 16", version: "1.1", style: { position: 'absolute', left: 12 } },
                        React.createElement("g", { id: "\u81EA\u5B9A\u4E49\u989C\u8272icon", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
                            React.createElement("rect", { id: "\u77E9\u5F62-copy-13", x: "0", y: "0", width: "16", height: "16" }),
                            React.createElement("path", { d: "M11.6,8 C11.0668463,8 10.6,7.53267432 10.6,7.00031267 C10.6,6.4666843 11.0668303,6 11.6,6 C12.1331697,6 12.6,6.46732568 12.6,7.00031267 C12.6,7.53204897 12.1331697,8 11.6,8 Z", id: "\u8DEF\u5F84", fill: "#5C5C5C", fillRule: "nonzero" }),
                            React.createElement("path", { d: "M9.80031267,5.4 C9.2666843,5.4 8.8,4.93316973 8.8,4.4 C8.8,3.86683027 9.26732568,3.4 9.80031267,3.4 C10.3333157,3.4 10.8,3.86683027 10.8,4.4 C10.8,4.93316973 10.3326903,5.4 9.80031267,5.4 Z", id: "\u8DEF\u5F84", fill: "#5C5C5C", fillRule: "nonzero" }),
                            React.createElement("path", { d: "M6.39999198,5.4 C5.86556688,5.4 5.4,4.93316973 5.4,4.4 C5.4,3.86683027 5.86556688,3.4 6.39999198,3.4 C6.93316599,3.4 7.4,3.86683027 7.4,4.4 C7.4,4.93316973 6.93316599,5.4 6.39999198,5.4 L6.39999198,5.4 Z", id: "\u8DEF\u5F84", fill: "#5C5C5C", fillRule: "nonzero" }),
                            React.createElement("path", { d: "M4.39969535,8 C3.86607126,8 3.4,7.53267432 3.4,7.00031267 C3.4,6.4666843 3.86605522,6 4.39967931,6 C4.9333034,6 5.4,6.46732568 5.4,7.00031267 C5.4,7.53204897 4.93267806,8 4.39967931,8 L4.39969535,8 Z", id: "\u8DEF\u5F84", fill: "#5C5C5C", fillRule: "nonzero" }),
                            React.createElement("path", { d: "M8,1.515792 L7.99793464,1.51578773 C6.27659245,1.5086773 4.6236985,2.18933226 3.40651538,3.40651538 C2.18933226,4.6236985 1.5086773,6.27659245 1.515792,8 C1.515792,11.603407 4.39659304,14.484208 8,14.484208 C8.34492832,14.484208 8.663792,14.164929 8.663792,13.820416 C8.663792,13.621135 8.62591397,13.5220821 8.44059328,13.32382 C8.15609688,12.9023751 8.04329333,12.6582686 8.04329333,12.2684693 C8.04329333,11.3709638 8.81057965,10.6046587 9.70708533,10.6046587 L11.103912,10.6046587 C13.0012677,10.6046587 14.484208,9.12114364 14.484208,7.22365333 C14.484208,4.08637183 11.6032997,1.515792 8,1.515792 Z M8.00103268,0.515792071 C8.0013769,0.515793446 8.00172113,0.515794844 8.00206536,0.515796266 L8,0.515792 C8.00034424,0.515792 8.00068847,0.515792021 8.0010327,0.515792062 Z", id: "\u8DEF\u5F84", stroke: "#5C5C5C", fillRule: "nonzero" }))),
                    React.createElement("span", { className: styles['color-picker-submenu-item'] }, this.props.customColorText)), style: { width: 'auto' } },
                React.createElement(Dropdown.Keep, null,
                    React.createElement(CustomSketch, { onChange: color => this.handleCustom(color, ColorFrom.CUSTOM) }))),
            React.createElement("div", { style: { padding: '0 11px' } }, this.props.customContent)));
    }
}
ColorPicker.contextType = EnvContext;
ColorPicker.defaultProps = {
    noColorText: '无颜色',
    recentColorsText: '最近使用',
    customColorText: '自定义颜色',
};

export { ColorFrom, ColorPicker };
//# sourceMappingURL=colorpicker.js.map
